import { useState } from 'react'

export default function NewsletterSection() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()
    if (!email.trim()) return
    setSubmitted(true)
  }

  return (
    <section className="section bg-dark">
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: '32px', maxWidth: '960px', margin: '0 auto',
      }}>
        <div style={{ maxWidth: '420px' }}>
          <h2 className="section-title" style={{ color: 'white', marginBottom: '8px' }}>
            Trekking tips, straight to your inbox.
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: 1.6 }}>
            Permit updates, seasonal route advice, and new departure dates. No spam, unsubscribe any time.
          </p>
        </div>

        <div style={{ flex: 1, minWidth: '280px', maxWidth: '420px' }}>
          {submitted ? (
            <p style={{ color: 'var(--green-mid)', fontSize: '14px', fontWeight: 500 }}>
              Thanks — you're on the list.
            </p>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <input
                type="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={{
                  flex: 1, minWidth: '200px', padding: '12px 18px', borderRadius: '40px',
                  border: '1px solid rgba(255,255,255,0.25)', background: 'rgba(255,255,255,0.08)',
                  color: 'white', fontSize: '14px', fontFamily: 'var(--sans)', outline: 'none',
                }}
              />
              <button type="submit" className="btn" style={{ background: 'var(--color-accent-cool)', color: 'var(--color-surface)' }}>Subscribe</button>
            </form>
          )}
        </div>
      </div>
    </section>
  )
}
